var map = {
	"./general-EN.json": [
		8224,
		224
	],
	"./general-ES.json": [
		5767,
		767
	],
	"./general-media.json": [
		2725,
		725
	],
	"./literals-EN.json": [
		9636,
		636
	],
	"./literals-ES.json": [
		3251,
		251
	],
	"./projects-EN.json": [
		638,
		638
	],
	"./projects-ES.json": [
		8389,
		389
	],
	"./projects-media.json": [
		5555,
		555
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 6845;
module.exports = webpackAsyncContext;